import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyUnblindingReason from "./UpdateStudyUnblindingReason";
import AddNewStudyUnblindingReason from "./AddNewStudyUnblindingReason";
import DeletedStudyUnblindingReason from "./DeletedStudyUnblindingReason";
import StudyUnblindingReasonActivities from "./StudyUnblindingReasonActivities";
import { eiwrsUnblindingReasonServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingReasonServices";

const StudyUnblindingReasonDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [reasonData, setReasonData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [reasonList, setReasonList] = useState([]);
  const [unblindingReasonCount, setUnblindingReasonCount] = useState(0);
  const [deletedStudySiteUnblindingReason, setDeletedStudyUnblindingReason] = useState([]);
  const [deletedStudySiteUnblindingReasonCount, setDeletedStudyUnblindingReasonCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [reasonId, setReasonId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [unblindingReasonActivity, setUnblindingReasonActivity] = useState([]);
  const [unblindingReasonActivityCount, setUnblindingReasonActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(unblindingReasonCount / itemsPerPage);

  const getEIWRSUnblindingReasonData = async (e) => {
    setLoading(true);
    let data = await eiwrsUnblindingReasonServices.getEIWRSUnblindingReasonData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setReasonList(data?.data || []);
    setUnblindingReasonCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSUnblindingReasonData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsUnblindingReasonServices.getEIWRSUnblindingReasonData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyUnblindingReason(data?.data || []);
    setDeletedStudyUnblindingReasonCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSUnblindingReason",
      studyId,
      reasonData?.reasonId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setUnblindingReasonActivity(data?.data || []);
    setUnblindingReasonActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [reasonData]);

  useEffect(() => {
    getEIWRSUnblindingReasonData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSUnblindingReason = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Unblinding Reason!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsUnblindingReasonServices.softDeleteRestoreEIWRSUnblindingReason(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingReasonData();
          setReasonId("");
          getDeletedEIWRSUnblindingReasonData();
          if (type === "restore") {
            getDeletedEIWRSUnblindingReasonData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setReasonId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {unblindingReasonCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteUnblindingReasonCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSUnblindingReasonData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={reasonId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyUnblindingReason getEIWRSUnblindingReasonData={getEIWRSUnblindingReasonData} />
          )}
          {loading ? (
            <PageLoader />
          ) : unblindingReasonCount === 0 ? (
            <NoDataFoundTable MSG={"Study Reason Matadata not found!"} />
          ) : reasonList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Reason Matadata not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Reason
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reasonList?.map((reasonData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${reasonId === reasonData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setReasonData(reasonData);
                          setReasonId(reasonData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setReasonData(reasonData);
                          setReasonId(reasonData?._id);
                        }}
                      >
                        {reasonData?.reason}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${reasonData?.unblindingReason}`}
                        onClick={(e) => {
                          setReasonData(reasonData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${reasonData?.unblindingReason}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSUnblindingReason(
                            reasonData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={unblindingReasonCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {reasonId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setReasonId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyUnblindingReasonActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                unblindingReasonActivity={unblindingReasonActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                reasonData={reasonData}
                unblindingReasonActivityCount={unblindingReasonActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyUnblindingReason
        Show={!toggle}
        Hide={setToggle}
        reasonData={reasonData}
        setReasonId={setReasonId}
        getEIWRSUnblindingReasonData={getEIWRSUnblindingReasonData}
        Title={"Update Reason"}
      />
      <DeletedStudyUnblindingReason
        Show={!toggle1}
        Hide={setToggle1}
        setReasonId={setReasonId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteUnblindingReason={deletedStudySiteUnblindingReason}
        getDeletedEIWRSUnblindingReasonData={getDeletedEIWRSUnblindingReasonData}
        deletedStudySiteUnblindingReasonCount={deletedStudySiteUnblindingReasonCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSUnblindingReason={softDeleteRestoreEIWRSUnblindingReason}
        Title={"Deleted Reason History"}
      />
    </>
  );
};

export default StudyUnblindingReasonDataList;
